require('./regular/index');
require('./modules/index');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js